import React from 'react';
import { Input as AntdInput } from 'antd';
import StyledInput from "components/Input/styled/StyledInput.js";

const Input = ({ type, name, autoComplete, ...props }) => {
	// For password fields, use Ant Design's Password component for proper masking
	if (type === 'password') {
		return (
			<AntdInput.Password
				{...props}
				type={type}
				name={name}
				autoComplete={autoComplete}
				style={{
					backgroundColor: 'var(--white)',
					padding: '12px 16px',
					color: 'var(--dark)',
					height: '40px',
					borderRadius: '8px',
					border: '1px solid var(--lightGrey)',
					fontSize: '13px',
					fontFamily: 'var(--fontProximaSemi)',
				}}
			/>
		);
	}

	// For all other input types, use the styled input
	return (
		<StyledInput
			{...props}
			type={type}
			name={name}
			autoComplete={autoComplete}
		/>
	);
};

export default Input;


